import { Suspense, useState } from "react"
import { Outlet } from "react-router-dom"
import { Sidebar } from "../components/Sidebar"
import { TopBar } from "../components/TopBar"
import { PageLoader } from "../components/ui/page-loader"
import { Sheet, SheetContent } from "../components/ui/sheet"
import { useIsDesktop } from "../hooks/useMediaQuery"

export function RootLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const isDesktop = useIsDesktop()

  return (
    <div className="flex h-screen overflow-hidden bg-bg">
      {/* Desktop Sidebar */}
      {isDesktop && <Sidebar className="hidden desktop:flex" />}

      {/* Mobile Drawer */}
      {!isDesktop && (
        <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
          <SheetContent side="left" className="w-sidebar p-0">
            <Sidebar onCollapse={() => setMobileMenuOpen(false)} />
          </SheetContent>
        </Sheet>
      )}

      {/* Main Content Area */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar onMenuClick={() => setMobileMenuOpen(true)} />

        {/* Page Content — local Suspense so lazy page swaps only load the
            content area and keep the sidebar/top bar in place. */}
        <main className="flex-1 overflow-y-auto bg-bg" aria-label="Main content">
          <Suspense fallback={<PageLoader className="h-full" />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  )
}
